import Carn from '@bluebeam/carnivore';
import { World } from '$legacyecstatic';
import { Components } from 'editor/components';
import CarnivoreDoc from 'editor/components/CarnivoreDoc';
import CarnivoreSheet from 'editor/components/CarnivoreSheet';
import DOMOverlay from 'editor/components/DOMOverlay';
import { EditorModes } from 'editor/components/EditorMode';
import MarkupKit from 'editor/components/MarkupKit';
import { EditorTools } from 'editor/components/Tool';
import createPunchEvents from './createPunchEvents';
import drawArrowEvents from './drawArrowEvents';
import drawLineEvents from './drawLineEvents';
import drawRectEvents from './drawRectEvents';
import drawTextEvents from './drawTextEvents';
import pointerEvents from './pointerEvents';
import postRFIEvents from './postRFIEvents';

export interface MouseDownArgs {
  markupKit: MarkupKit;
  world: World<Components>;
  evt: PointerEvent; // update this.
  hit: Carn.Hit;
  carnDoc: CarnivoreDoc;
  sheetComp: CarnivoreSheet;
  domOverlay: DOMOverlay;
  mode: EditorModes;
}

export interface MouseMoveArgs {
  markupKit: MarkupKit;
  world: World<Components>;
  evt: PointerEvent; // update this.
  hit: Carn.Hit;
  carnDoc: CarnivoreDoc;
  sheetComp: CarnivoreSheet;
  domOverlay: DOMOverlay;
  mode: EditorModes;
}

export interface MouseUpArgs {
  markupKit: MarkupKit;
  world: World<Components>;
  evt: PointerEvent; // update this.
  hit: Carn.Hit;
  carnDoc: CarnivoreDoc;
  sheetComp: CarnivoreSheet;
  domOverlay: DOMOverlay;
  mode: EditorModes;
}

export interface ClickArgs {
  markupKit: MarkupKit;
  world: World<Components>;
  evt: PointerEvent; // update this.
  hit: Carn.Hit;
  carnDoc: CarnivoreDoc;
  sheetComp: CarnivoreSheet;
  domOverlay: DOMOverlay;
  mode: EditorModes;
}

export interface DBLClickArgs {
  markupKit: MarkupKit;
  world: World<Components>;
  evt: PointerEvent; // update this.
  hit: Carn.Hit;
  carnDoc: CarnivoreDoc;
  sheetComp: CarnivoreSheet;
  domOverlay: DOMOverlay;
  mode: EditorModes;
}

export interface MouseToolEvents {
  mouseDown: (args: MouseDownArgs) => void;
  mouseMove: (args: MouseMoveArgs) => void;
  mouseUp: (args: MouseUpArgs) => void;
  click: (args: ClickArgs) => void;
  dblclick: (args: DBLClickArgs) => void;
}

export interface SheetEventHandlers {
  [EditorTools.Pointer]: MouseToolEvents;
  [EditorTools.DrawRectangle]: MouseToolEvents;
  [EditorTools.DrawLine]: MouseToolEvents;
  [EditorTools.DrawArrow]: MouseToolEvents;
  [EditorTools.DrawText]: MouseToolEvents;
  [EditorTools.CreatePunch]: MouseToolEvents;
  [EditorTools.PostRFI]: MouseToolEvents;
}

const sheetEventsHandlers: SheetEventHandlers = {
  [EditorTools.Pointer]: pointerEvents,
  [EditorTools.DrawRectangle]: drawRectEvents,
  [EditorTools.DrawLine]: drawLineEvents,
  [EditorTools.DrawArrow]: drawArrowEvents,
  [EditorTools.DrawText]: drawTextEvents,
  [EditorTools.CreatePunch]: createPunchEvents,
  [EditorTools.PostRFI]: postRFIEvents,
};

export default sheetEventsHandlers;
